import { initClient, InitClientArgs, InitClientReturn, tsRestFetchApi } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import { ApiFetcherArgs } from "@ts-rest/core/src/lib/client";
import { publicApiContract } from "tekkr-common/dist/model/api/public.contract";
import { getFirebaseAuth } from "../../auth/firebase";
import { config } from "../../lib/config";
import { OrgSelector } from "../../auth/org-provider";

export class ApiError extends Error {
    constructor(
        readonly status: number,
        readonly body: unknown
    ) {
        super(`Request failed with status code ${status}`);
    }
}

function throwApiErrorOnNonSuccess(res: { status: number; body: unknown }) {
    if (res.status < 200 || res.status >= 400) {
        throw new ApiError(res.status, res.body);
    }
}

export async function getDefaultApiClientHeaders(): Promise<Record<string, string>> {
    const headers: Record<string, string> = {};
    const token = await getFirebaseAuth().currentUser?.getIdToken();
    if (!token) {
        throw new Error("no authorization token available");
    }
    headers["Authorization"] = token;
    const orgId = OrgSelector.getSelectedOrgId();
    if (orgId) {
        headers["X-Tekkr-Org"] = orgId;
    }
    return headers;
}

export type ApiClient = InitClientReturn<typeof apiContract, InitClientArgs>;

export const apiClient: ApiClient = initClient(apiContract, {
    baseUrl: config.serviceHost,
    api: async (args: ApiFetcherArgs) => {
        args.headers = {
            ...(await getDefaultApiClientHeaders()),
            ...args.headers,
        };
        const res = await tsRestFetchApi(args);
        throwApiErrorOnNonSuccess(res);
        return res;
    },
});

export type PublicApiClient = InitClientReturn<typeof publicApiContract, InitClientArgs>;

export const publicApiClient: PublicApiClient = initClient(publicApiContract, {
    baseUrl: config.serviceHost,
    api: async (args: ApiFetcherArgs) => {
        const res = await tsRestFetchApi(args);
        throwApiErrorOnNonSuccess(res);
        return res;
    },
});
